import React from "react";

const Loader = () => {
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        zIndex: Number.MAX_SAFE_INTEGER,
        backgroundColor: "#fffefe63",
        position: "fixed",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img width="80px" src="../Assets/images/AG-loader.gif" alt="Loader" />
    </div>
  );
};

export default Loader;


